import { CommonModule } from '@angular/common';
import { Component, Injector, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import {extractErrorMessage, goBack} from '../../../../common/common';
import { Group } from '../../../../model/group.model';
import {ApiService, CustomHttpParams} from 'src/app/services/api.service';
import {HttpParams} from "@angular/common/http";

@Component({
  selector: 'app-create-group',
  standalone: true,
  imports: [RouterModule, CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './create-group.component.html',
  styleUrl: './create-group.component.scss'
})
export class CreateGroupComponent implements OnInit{

  // FORM with validators
  groupForm = new FormGroup({
    id: new FormControl<string>('', [Validators.required]),
    division: new FormControl<string>('', [Validators.required]),
    label: new FormControl<string | undefined>(''),
  });

  public editing: boolean = false;
  public error: string | null = null;
  public group_id: number;
  public router: Router
  public group: Group = {
    id: 0,
    group_id: '',
    division: '',
    label: '',
    updated_by: ''
  };
  formsSubscribe: any;

  constructor(private injector: Injector, private createGroupService: ApiService){
    this.router = injector.get(Router);
    this.router.events.subscribe((event: any) => {
      if (event?.snapshot?.params.id) {
        this.editing = true;
        this.group_id = event.snapshot.params.id;
      }
    });
  }

  setFormsDefaultValue(){
    this.groupForm.controls.id.setValue(this.group?.group_id)
    this.groupForm.controls.division.setValue(this.group?.division);
    this.groupForm.controls.label.setValue(this.group?.label);
  }

  ngOnInit(): void {
    if (this.editing) {
      const queryParams: CustomHttpParams = {
        'depth': 1,
        'id': Number(this.group_id)
      }
      this.createGroupService.getGroups(queryParams).subscribe({
        next: (response: Group[]) => {
          this.group = response[0];
          this.setFormsDefaultValue();
        },
        error: (err) => {
          console.error(err);
          this.error = extractErrorMessage(err);
        }
      });
    }

    this.formsSubscribe = this.groupForm.controls.id.valueChanges.subscribe(
      (val: any) => this.group.group_id = val
    );

    this.formsSubscribe = this.groupForm.controls.division.valueChanges.subscribe(
      (val: any) => this.group.division = val
    );

    this.formsSubscribe = this.groupForm.controls.label.valueChanges.subscribe(
      (val: any) => this.group.label = val
    );
  }

  save(){
    // Mark all fields as touched to trigger validation display
    this.groupForm.markAllAsTouched();

    // Check form validity instead of using popup
    if (this.groupForm.invalid) {
      return;
    }

    if(this.editing) {
      this.createGroupService.editGroups(this.group).subscribe({
        next: () => goBack('/groups', this.router),
        error: (err) => {
          console.error(err);
          this.error = extractErrorMessage(err);
        }
      });
    } else {
      const createGroup = {
        "group_id": this.group.group_id,
        "division": this.group.division,
        "label": this.group.label
      }
      this.createGroupService.createGroup(createGroup).subscribe({
        next: () => goBack('/groups', this.router),
        error: (err) => {
          console.error(err);
          this.error = extractErrorMessage(err);
        }
      });
    }
  }

  backPage(url: string, router: Router){
    goBack(url, router);
  }
}
